import {Building} from './BuildingData';
import {Helper} from './Helper';

/**
 * Created by samuel on 01/03/2017.
 */

export class Campus {
  public id: string;
  public name: string;
  public released: boolean;
  public buildingData: { [key: string]: Building };

  public cover: string;
  public assetBundles: { [platform: string]: string };

  constructor(obj: any) {
    this.id = obj.id ? obj.id : '';
    this.name = obj.name ? obj.name : '';
    this.released = obj.released ? obj.released : false;
    this.buildingData = obj.buildingData ? obj.buildingData : {};
    this.buildingData = Helper.MapDict(this.buildingData, (objec: any) => {
      return new Building(objec);
    });

    this.cover = './assets/unknown_campus.png';
    this.assetBundles = {};
  }

  public hasAssetbundle(platform: string): boolean {
    return Object.keys(this.assetBundles).includes(platform);
  }

  public buildingIDs(): string[] {
    return Object.keys(this.buildingData);
  }

  public AsData(): any {
    const buildingData = Helper.MapDict(this.buildingData, (obj: Building) => {
      return obj.AsObject();
    });

    return {
      name: this.name,
      released: this.released,
      buildingData: buildingData,
      platforms: this.assetBundles,
    };
  }

  public AsText(): string {
    return JSON.stringify(this.AsData());
  }
}
